<script setup lang="ts">
import type { ClickEvent } from '@autobid/ui/types/Vue'
import type { FormKitFrameworkContext } from '@formkit/core'
import Checkbox from './Checkbox.vue'

interface Props {
  context: FormKitFrameworkContext
}

defineProps<Props>()

function handleClick(e: ClickEvent) {
  if (e.target.tagName.toLowerCase() === 'a') {
    window.open(String(e.target.getAttribute('href')), '_blank')
  }
}
</script>

<template>
  <Checkbox
    :checked="Boolean(context.value ?? false)"
    :label="context.label || ''"
    :aria-required="context.state.required ? 'true' : 'false'"
    small
    @change="context.node.input"
    @click="handleClick"
  />
</template>
